export enum ReportItems {
    Mandates = 0,
    BvnLinking,
    LinkedAccounts,
    Recovery,
    Settlement
  }